import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import { useI18n } from "vue-i18n";
import { defineComponent, ref, computed, reactive } from "vue";
import { TeamLevel } from "@/interfaces/teams/teams";
import BookingModule from "@/store/modules/booking";
import { BookingStep } from "@/constants/booking";
import { createTeams, updateScannedBooking } from "@/utils/vue-helpers/booking";
import cardsIcon from "@/assets/images/svg/cards.svg";
import closeIcon from "@/assets/images/svg/close.svg";
import successIcon from "@/assets/images/svg/round-check.svg";
import arrowDownIcon from "@/assets/images/svg/arrow-down.svg";
import { postPairTeam, patchPairTeam, deleteTeam } from "@/api/teams/teams";
import Timeout from "await-timeout";
import { getBookingWithUUID } from "@/api/gql/product-slot-boooking";
import { attachedVueElement, detachVueElement } from "@/utils/helpers/scanner";
import ScannerModule from "@/store/modules/scanner";
import { watch } from "vue";
import { fetchBookingTeams } from "@/utils/helpers/teams";
import { LogService } from "@/services/logging";
import { cloneDeep, debounce, isEqual } from "lodash";
import NotificationService from "@/services/notification.service";
import AppModule from "@/store/modules/app";
import { ScanningStatus } from "@/types/db/product-slot-state";
import { nowDB } from "@/utils/helpers/dates";
import UserModule from "@/store/modules/user";
import POSConfigModule from "@/store/modules/pos-config";
import { Virtual, FreeMode, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import "swiper/swiper.scss"; // core Swiper

import "swiper/modules/navigation/navigation.scss"; // Navigation module

import "swiper/modules/pagination/pagination.scss"; // Pagination module

var swiper = null;
export default defineComponent({
  name: "Teams",
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide
  },
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var teamsArray = ref([]);
    var currentTeam = ref(0);
    var isLoading = ref(false);
    var bookingId = ref();
    var bookingToken = ref();

    function setSwiperRef(swp) {
      swiper = swp;
    }

    var nameRegex = /^[^/\\#]*$/;
    var formRef = ref();
    var form = ref({
      name: "",
      level: TeamLevel.MEDIUM
    });
    var rules = reactive({
      name: [{
        pattern: nameRegex,
        message: t("teams.invalid-name"),
        trigger: ["blur", "change"]
      }]
    });
    var levelOptions = [{
      label: t("teams.level-easy"),
      value: TeamLevel.EASY
    }, {
      label: t("teams.level-medium"),
      value: TeamLevel.MEDIUM
    }, {
      label: t("teams.level-hard"),
      value: TeamLevel.HARD
    }];

    function validateForm() {
      return _validateForm.apply(this, arguments);
    }

    function _validateForm() {
      _validateForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isValid;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (formRef.value) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", false);

              case 2:
                isValid = false;

                if (form.value.name) {
                  isValid = true;
                } // formRef.value.validate(async (valid) => {
                //   isValid = valid || false;
                // });


                return _context.abrupt("return", isValid);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _validateForm.apply(this, arguments);
    }

    var isVisible = computed(function () {
      return BookingModule.bookingStep === BookingStep.Teams;
    });
    var scannerTog = computed(function () {
      return ScannerModule.tog;
    });

    function waitForNfcTag() {
      return _waitForNfcTag.apply(this, arguments);
    }

    function _waitForNfcTag() {
      _waitForNfcTag = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve) {
                  var nfcTagWatcher = watch(scannerTog, function () {
                    console.log("watcher triggered: ", ScannerModule.value);
                    console.log("scanned: ", ScannerModule.value);
                    LogService.info("Teams: scanner watcher triggered, value = ".concat(ScannerModule.value));

                    if (ScannerModule.value) {
                      nfcTagWatcher(); // Remove the watcher

                      // Remove the watcher
                      resolve(ScannerModule.value);
                    }
                  }, {
                    deep: true
                  });
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _waitForNfcTag.apply(this, arguments);
    }

    var nfcTag = ref(""); // the following array will contain all the teams that should be cancelled

    var cancelledTeams = ref([]);
    var bookingCopy = ref(cloneDeep(BookingModule.selectedBooking));
    return {
      t: t,
      isVisible: isVisible,
      teamsArray: teamsArray,
      currentTeam: currentTeam,
      cardsIcon: cardsIcon,
      closeIcon: closeIcon,
      successIcon: successIcon,
      arrowDownIcon: arrowDownIcon,
      isLoading: isLoading,
      bookingId: bookingId,
      waitForNfcTag: waitForNfcTag,
      form: form,
      rules: rules,
      formRef: formRef,
      validateForm: validateForm,
      nfcTag: nfcTag,
      cancelledTeams: cancelledTeams,
      bookingCopy: bookingCopy,
      levelOptions: levelOptions,
      bookingToken: bookingToken,
      modules: [Navigation, Virtual, FreeMode],
      setSwiperRef: setSwiperRef
    };
  },
  methods: {
    close: function close() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var isSameObj;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                isSameObj = isEqual(BookingModule.selectedBooking, _this.bookingCopy);

                if (isSameObj) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 4;
                return updateScannedBooking(_this.bookingCopy);

              case 4:
                BookingModule.setBookingStep({
                  bookingUUID: BookingModule.selectedBookingUUID,
                  step: BookingStep.CompleteOrder
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    debouncedPair: debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              this.isLoading = true;
              _context4.next = 3;
              return this.pair();

            case 3:
              this.isLoading = false;

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    })), 400),
    scanAndPair: function scanAndPair() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var isManualPairingTest, validName, nfcTag;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                LogService.info("User clicked to scan and pair");
                isManualPairingTest = POSConfigModule.groupInfo && POSConfigModule.groupInfo.id === 16342;
                console.log("----- isManualPairingTest");
                console.log(isManualPairingTest);

                if (isManualPairingTest) {
                  _context5.next = 11;
                  break;
                }

                _context5.next = 7;
                return _this2.validateForm();

              case 7:
                validName = _context5.sent;

                if (validName) {
                  _context5.next = 11;
                  break;
                }

                LogService.info("Team name not valid");
                return _context5.abrupt("return");

              case 11:
                _this2.isLoading = true;

                if (isManualPairingTest) {
                  _context5.next = 24;
                  break;
                }

                _context5.next = 15;
                return _this2.waitForNfcTag();

              case 15:
                nfcTag = _context5.sent;

                if (nfcTag) {
                  _context5.next = 20;
                  break;
                }

                // nfcTag not available
                _this2.isLoading = false;
                LogService.info("No NFC Tag was provided");
                throw new Error("No NFC Tag was provided");

              case 20:
                _this2.nfcTag = nfcTag;
                LogService.info("Teams: received NFC tag: ".concat(nfcTag));
                _context5.next = 26;
                break;

              case 24:
                _this2.nfcTag = "ABCDEFGH";
                LogService.info("Teams: received NFC tag: ".concat(_this2.nfcTag));

              case 26:
                _context5.next = 28;
                return _this2.debouncedPair();

              case 28:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    pair: function pair() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var team, formattedNfcTag, isManualPairingTest, isValidNfcTag, _res, teamData, error, res, _teamData, _error;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                team = _this3.teamsArray[_this3.currentTeam];
                team.name = _this3.form.name.trim();
                team.teamLevel = _this3.form.level; // Reforamtting the NFC tag
                // Remove white spaces and convert to uppercase

                console.log("nfcTag before format ".concat(_this3.nfcTag));
                formattedNfcTag = _this3.nfcTag.replace(/\s+/g, "").toUpperCase();
                console.log("nfcTag after format ".concat(formattedNfcTag));
                isManualPairingTest = POSConfigModule.groupInfo && POSConfigModule.groupInfo.id === 16342;

                if (isManualPairingTest) {
                  _context6.next = 15;
                  break;
                }

                // Check if the tag contains only 16 ASCII hexadecimal characters
                isValidNfcTag = /[0-9A-F]+$/i.test(formattedNfcTag);

                if (isValidNfcTag) {
                  _context6.next = 15;
                  break;
                }

                NotificationService.showCustomError(_this3.t("teams.invalid-tag").replace("xxxxxxx", formattedNfcTag));
                LogService.info("Invalid formatted nfcTag ".concat(formattedNfcTag));
                console.log("Invalid formatted nfcTag ".concat(formattedNfcTag));
                return _context6.abrupt("return");

              case 15:
                team.nfcTag = formattedNfcTag;

                if (!team.uuid) {
                  _context6.next = 35;
                  break;
                }

                LogService.info("Teams: going to patch team with uuid: ".concat(team.uuid), team); // this team aready exists so let's do a PUT

                _context6.next = 20;
                return patchPairTeam(team, _this3.bookingId, _this3.bookingToken);

              case 20:
                _res = _context6.sent;

                if (!(_res && _res.status === "success")) {
                  _context6.next = 29;
                  break;
                }

                teamData = _res.data.teamOfParticipants;
                team.paired = true;
                team.uuid = teamData.uuid;
                LogService.info("Teams: successfully updated team with uuid: ".concat(team.uuid), team); // scan the tickets of this team

                _this3.scanTeamTickets(team.ticketUuids);

                _context6.next = 34;
                break;

              case 29:
                if (!_res) {
                  _context6.next = 34;
                  break;
                }

                LogService.info("Teams: error when patching team uuid: ".concat(team.uuid), {
                  params: {
                    errorResponse: _res,
                    team: team
                  }
                });
                error = new Error();
                error.message = _res.data.errors[0];
                throw error;

              case 34:
                return _context6.abrupt("return");

              case 35:
                LogService.info("Teams: going to POST create new team", team);
                _context6.next = 38;
                return postPairTeam(team, _this3.bookingId, _this3.bookingToken);

              case 38:
                res = _context6.sent;

                if (!(res && res.status === "success")) {
                  _context6.next = 47;
                  break;
                }

                _teamData = res.data.teamOfParticipants;
                team.paired = true;
                team.uuid = _teamData.uuid;
                LogService.info("Teams: successfully created team with uuid: ".concat(team.uuid), team); // scan the tickets of this team

                _this3.scanTeamTickets(team.ticketUuids);

                _context6.next = 52;
                break;

              case 47:
                if (!res) {
                  _context6.next = 52;
                  break;
                }

                LogService.info("Teams: error when creating team uuid: ".concat(team.uuid), {
                  params: {
                    errorResponse: res,
                    team: team
                  }
                });
                _error = new Error();
                _error.message = res.data.errors[0];
                throw _error;

              case 52:
                _context6.next = 59;
                break;

              case 54:
                _context6.prev = 54;
                _context6.t0 = _context6["catch"](0);
                console.log(_context6.t0);

                if (_context6.t0.message && String(_context6.t0.message).includes("The team with name")) {
                  NotificationService.showCustomError(_this3.t("teams.name-taken"));
                }

                LogService.info("Teams: error when scanning/creating/patching team", {
                  params: {
                    error: _context6.t0,
                    team: _this3.teamsArray[_this3.currentTeam]
                  }
                });

              case 59:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 54]]);
      }))();
    },
    proceed: function proceed() {
      if (this.currentTeam === this.teamsArray.length - 1) {
        // this is the last team let's close the UI
        this.close();
        return;
      }

      this.currentTeam++;
      this.form.name = this.teamsArray[this.currentTeam].name;
      this.form.level = this.teamsArray[this.currentTeam].teamLevel || TeamLevel.MEDIUM;
    },
    unpair: function unpair() {
      this.teamsArray[this.currentTeam].paired = false;
    },
    mergedTeams: function mergedTeams(createdTeams, fetchedTeams) {
      var _this4 = this;

      var linkedTeams = [];

      var _iterator = _createForOfIteratorHelper(fetchedTeams),
          _step;

      try {
        var _loop = function _loop() {
          var fetchedTeam = _step.value;
          // find a matching created team based on properties: startDateTime, endDateTime, roomPlayers
          var matchingCreatedTeamIndex = createdTeams.findIndex(function (createdTeam) {
            return createdTeam.startDateTime === fetchedTeam.startDateTime && createdTeam.endDateTime === fetchedTeam.endDateTime && createdTeam.roomPlayers === fetchedTeam.roomPlayers;
          });

          if (matchingCreatedTeamIndex !== -1) {
            // let's link the tickets of the created team to the fetched team
            fetchedTeam.ticketUuids = createdTeams[matchingCreatedTeamIndex].ticketUuids; // if a match is found, add the fetched team to the result

            linkedTeams.push(fetchedTeam); // remove the matched created team from the array to avoid duplicates

            createdTeams.splice(matchingCreatedTeamIndex, 1);
          } else {
            // this teams was already created, but now it's tickets are removed / changed
            // this teams should be cencelled
            _this4.cancelledTeams.push(fetchedTeam);
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      linkedTeams.push.apply(linkedTeams, _toConsumableArray(createdTeams));
      return linkedTeams;
    },
    selectTeam: function selectTeam(index) {
      this.currentTeam = index;
      this.form.name = this.teamsArray[index].name;
      this.form.level = this.teamsArray[index].teamLevel || TeamLevel.MEDIUM;
    },
    scanTeamTickets: function scanTeamTickets(pssUuids) {
      LogService.info("Going to scan team's tickets, pssUuids: ".concat(pssUuids));
      var booking = this.bookingCopy;
      var now = nowDB();

      for (var i = 0; i < booking.pssList.length; i++) {
        var pss = booking.pssList[i];

        if (pss.scanningStatus !== ScanningStatus.Scanned && pssUuids.includes(String(pss.uuid))) {
          pss.scanningStatus = ScanningStatus.Scanned;
          pss.scanningUserId = UserModule.userId;
          pss.updatedAt = now;
        }
      }
    }
  },

  /**
   * When the Teams vue loads
   * we pull the bookingId if we don't have it yet
   * we fetch all the existing teams
   * we create teams locally based on the booking's tickets
   * we compare and merge the fetched teams with the locally created teams
   * we cancel the extra teams that are attached to cancelled tickets
   */
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      var booking, bookingInfo, repeat, newTeams, fetchedTeams, i, team, res;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              // attach the scanner
              LogService.info("Scanner: going to attach scanner to Teams vue");
              attachedVueElement();
              AppModule.updatedIsLoading(true);
              booking = BookingModule.selectedBooking; // get the bookingId

              // repeat request 3 times
              repeat = 0;
              _context7.prev = 5;

            case 6:
              if (!(repeat++ < 3)) {
                _context7.next = 16;
                break;
              }

              _context7.next = 9;
              return getBookingWithUUID(BookingModule.selectedBookingUUID);

            case 9:
              bookingInfo = _context7.sent;

              if (!(bookingInfo != null)) {
                _context7.next = 12;
                break;
              }

              return _context7.abrupt("break", 16);

            case 12:
              _context7.next = 14;
              return Timeout.set(3000);

            case 14:
              _context7.next = 6;
              break;

            case 16:
              if (!(!bookingInfo || !bookingInfo.id || !bookingInfo.token)) {
                _context7.next = 19;
                break;
              }

              _this5.close();

              throw new Error("Booking with ".concat(BookingModule.selectedBookingUUID, " not synced"));

            case 19:
              _this5.bookingId = bookingInfo.id;
              _this5.bookingToken = bookingInfo.token;
              _context7.next = 23;
              return createTeams();

            case 23:
              newTeams = _context7.sent;
              _context7.next = 26;
              return fetchBookingTeams(_this5.bookingId);

            case 26:
              fetchedTeams = _context7.sent;

              if (fetchedTeams.length) {
                _context7.next = 31;
                break;
              }

              _this5.teamsArray = newTeams;
              _context7.next = 48;
              break;

            case 31:
              _this5.teamsArray = _this5.mergedTeams(newTeams, fetchedTeams); // let's send a delete request to cancel all the extra teams
              // an extra team is a team that is already on backend, but it's tickets are removed from the booking

              i = 0;

            case 33:
              if (!(i < _this5.cancelledTeams.length)) {
                _context7.next = 48;
                break;
              }

              team = _this5.cancelledTeams[i];
              LogService.info("Teams: going to cancel team with uuid: ".concat(team.uuid));
              _context7.prev = 36;
              _context7.next = 39;
              return deleteTeam(String(team.uuid), Number(bookingInfo.id), bookingInfo.token);

            case 39:
              res = _context7.sent;
              _context7.next = 45;
              break;

            case 42:
              _context7.prev = 42;
              _context7.t0 = _context7["catch"](36);
              LogService.info("Teams: error when cancelling team with uuid: ".concat(team.uuid));

            case 45:
              i++;
              _context7.next = 33;
              break;

            case 48:
              _this5.form.name = _this5.teamsArray[0].name;
              _this5.form.level = _this5.teamsArray[0].teamLevel || TeamLevel.MEDIUM;
              AppModule.updatedIsLoading(false);
              _context7.next = 57;
              break;

            case 53:
              _context7.prev = 53;
              _context7.t1 = _context7["catch"](5);
              console.log(_context7.t1);
              AppModule.updatedIsLoading(false);

            case 57:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[5, 53], [36, 42]]);
    }))();
  },
  unmounted: function unmounted() {
    // detach the scanner
    detachVueElement();
  }
});